import { render, staticRenderFns } from "./EfficiencyView.vue?vue&type=template&id=706f4476"
import script from "./EfficiencyView.vue?vue&type=script&lang=js"
export * from "./EfficiencyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports